export default "__VITE_PUBLIC_ASSET__60990582__"